module.exports = {"appId":"fulfillment","appUrl":"api.fulfillment.local","appVersion":"beta","useSSL":false,"currentVersion":""}


//////////////////
// WEBPACK FOOTER
// ./src/config/development/application-settings.json
// module id = 3074
// module chunks = 1